// src/components/Admin/PostManager/ReasonModal.jsx
import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField,
} from '@mui/material';

export default function ReasonModal({
    open, onClose, onSubmit, actionLabel = '처리',
}) {
    const [memo, setMemo] = useState('');

    /* 모달 열리면 입력 초기화 */
    useEffect(() => {
        if (open) setMemo('');
    }, [open]);

    const handleSubmit = () => {
        if (!memo.trim()) {
            alert(`${actionLabel} 사유를 입력해주세요.`);
            return;
        }
        onSubmit(memo.trim());
    };

    const handleClose = () => {
        onClose();
        setMemo('');
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
            sx={{
                '& .MuiDialog-paper': {
                    /* 모바일(≤600px): 90 % 축소 */
                    '@media (max-width:600px)': {
                        transform: 'scale(0.9)',
                        transformOrigin: 'top left',
                    },
                },
            }}
        >
            <DialogTitle>{actionLabel} 사유 입력</DialogTitle>

            <DialogContent>
                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    minRows={3}
                    placeholder={`${actionLabel} 사유를 입력하세요`}
                    value={memo}
                    onChange={(e) => setMemo(e.target.value)}
                    sx={{
                        /* 모바일: 폰트 살짝 축소 */
                        '@media (max-width:600px)': { fontSize: '0.85rem' },
                    }}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>취소</Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    sx={{
                        '@media (max-width:600px)': { fontSize: '0.8rem', px: 1.6 },
                    }}
                >
                    확인
                </Button>
            </DialogActions>
        </Dialog>
    );
}
